var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYawww = function SvgYawww(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Yawww_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14B8A6",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.79 25.095c-4.418 0-8.013-3.596-8.013-8.015 0-4.418 3.595-8.013 8.014-8.013 2.254 0 4.416.957 5.933 2.627a1.25 1.25 0 1 1-1.851 1.68 5.526 5.526 0 0 0-4.082-1.808 5.52 5.52 0 0 0-5.514 5.514 5.52 5.52 0 0 0 5.514 5.514c1.55 0 3.038-.659 4.082-1.807a1.25 1.25 0 0 1 1.85 1.681 8.032 8.032 0 0 1-5.932 2.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.208 31.491a8.03 8.03 0 0 1-5.933-2.627 1.25 1.25 0 0 1 1.85-1.68 5.524 5.524 0 0 0 4.083 1.807 5.52 5.52 0 0 0 5.513-5.513 5.52 5.52 0 0 0-5.513-5.514c-1.551 0-3.04.659-4.083 1.808a1.25 1.25 0 1 1-1.85-1.681 8.03 8.03 0 0 1 5.933-2.627c4.419 0 8.014 3.595 8.014 8.014 0 4.418-3.596 8.013-8.014 8.013Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Yawww_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgYawww;